import { useQuery } from '@tanstack/react-query';
import { api } from '../../services/api';

export interface Tag {
  id: string;
  projectId: string;
  name: string;
  color: string;
}

export function useTagSuggestions(projectId: string, query: string) {
  return useQuery<Tag[]>({
    queryKey: ['tagSuggestions', projectId, query],
    queryFn: () => api.get<Tag[]>(`/project/${projectId}/tag/all/suggest?query=${encodeURIComponent(query)}`),
    enabled: !!projectId,
    staleTime: 30_000,
  });
}

export function useTagsByIds(projectId: string, ids: string[]) {
  return useQuery<Tag[]>({
    queryKey: ['tagsByIds', projectId, ids],
    queryFn: () => api.get<Tag[]>(`/project/${projectId}/tags/${ids.join(',')}`),
    enabled: !!projectId && ids.length > 0,
  });
}
